<template>
  <section>
    <div>404</div>
  </section>
</template>

<script>
  import ApplicationTemplate from '../components/application.vue'
  import { eventBus }     from "../event_bus.js"

  export default {
    data() {
      return {};
    },
    computed: {},
    methods: {},
    components: { ApplicationTemplate },
    created,
    destroyed,
  }

  function created() {
  }

  function destroyed() {
  }
</script>